<label
  for="image-input-{{ uniqueId }}"
  class="full-width"
  [class.pb-0]="helpText"
  [class.has-text-danger]="showErrors && isEmpty() && required"
>
  @if (renderLabelAsHtml) {
  <span [innerHTML]="label"></span>
  } @else {
  {{ label }}
  }
  @if (required) {
  <span class="required-indicator has-text-danger">*required</span>
  }
</label>

@if (helpText) {
<p class="help mb-4 mt-0">{{ helpText }}</p>
} @if (showErrors && isEmpty() && required) {
<p class="help mb-4 mt-0 has-text-danger">Please select an option.</p>
}

<div
  class="radio-options-wrapper"
  [appHtmlTooltip]="readonly && htmlTooltip ? htmlTooltip : null"
  [appHtmlTooltipPosition]="readonly && htmlTooltip ? 'top' : 'bottom'"
>
  <div class="columns is-multiline">
    @for (option of selectOptions; track $index) {
    <div class="column is-12-mobile" (click)="select(option)">
      <div class="control is-fullheight">
        <label
          class="radio is-boxed radio-label is-align-items-flex-start mt-0 p-4"
          [class.is-disabled]="readonly || option.disabled"
          [class.is-selected]="option.selected"
          [class.is-error]="showErrors && isEmpty() && required"
        >
          <span class="radio-cta">
            <span
              class="radio-label has-text-black"
              [class.has-text-grey]="option.disabled"
            >
              {{ option.label }}
            </span>
            <span
              class="radio-sub-label has-text-grey-dark mt-2"
              [class.has-text-grey]="option.disabled"
            >
              {{ option.subLabel }}
            </span>
          </span>
        </label>
      </div>
    </div>
    }
  </div>
</div>
